import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import * as styles from './BaseCheckbox.module.scss';
import { BodyTextMedium } from '../../Typography/Typography';
export const BaseCheckbox = props => {
    const { className, label, value, ...otherProps } = props;
    const containerStyles = clsx([styles.container, className]);
    return (_jsxs("label", { className: containerStyles, children: [_jsx("input", { checked: value, ...otherProps, type: "checkbox" }), _jsx(BodyTextMedium, { as: "span", children: label })] }));
};
